require('./').polyfill()



//////////////////
// WEBPACK FOOTER
// ./~/raf/polyfill.js
// module id = 2965
// module chunks = 0